/* eslint-disable no-unused-vars */
enum LockStatus {
  MANUAL_LOCKED = 'MANUAL_LOCKED',
  AUTO_LOCKED = 'AUTO_LOCKED',
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED',
}

export default LockStatus;
